import Div from 'src/components/atomic/atom/Div'
import Button from 'src/components/atomic/atom/Button'
import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import { useNavigate } from 'react-router-dom'
import { COLOR } from 'src/constants/colors'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useTranslation } from 'react-i18next'
import useDynamicWindowHeightHook from 'src/hooks/useDynamicWindowHeight.hook'

const ExplorerMainDeleteNavBtn = () => {
  const { t } = useTranslation()
  const { setMediaStyle, currentMedia } = useMediaQueryHook()
  const navigate = useNavigate()
  const { windowHeight } = useDynamicWindowHeightHook()

  const DeleteNavButtonStyle = {
    maxWidth: setMediaStyle('396px', '600px', '100%'),
    width: '100%',
    position: currentMedia === 'pc' && windowHeight >= 945 ? 'fixed' : 'unset',
    bottom: currentMedia === 'pc' ? '41px' : 'unset',
    margin: setMediaStyle(windowHeight >= 945 ? '' : '155px 0 0 0', '45px 0', '45px 0'),
  }

  return (
    <Div style={DeleteNavButtonStyle} onClick={() => navigate('/explorer/delete')}>
      <Button option={'bigIconText'} $bgColor={COLOR.black2}>
        <Svg name={'explorer_deleteData_icon'} />
        <Span
          $text_align={'left'}
          $margin={'0 0 0 12px'}
          option={setMediaStyle('medium_bold', 'medium_bold', 'small_bold')}
        >
          {t('EXPLORER.GO_DELETE', { defaultValue: 'Delete Data' })}
        </Span>
        <Svg color={COLOR.black20} name={'arrow'} />
      </Button>
    </Div>
  )
}

export default ExplorerMainDeleteNavBtn
